import React from 'react';
import { SignIn, UserButton, useUser } from "@clerk/clerk-react";

interface MoreToolsProps {
  isAuthenticated: boolean;
}

const MoreTools: React.FC<MoreToolsProps> = ({ isAuthenticated }) => {
  const { user } = useUser();

  return (
    <div className="more-tools">
      <h2>Coming Soon: More SaaS Tools</h2>
      <p className="tools-description">
        We are working on integrations with Stripe, Chargebee and others, as well as other useful SaaS tools.
        Sign up to stay informed. We will not share your email with anyone and will only contact you once the
        new tools are out (probably once every 3 months).
      </p>

      <div className="auth-section">
        {isAuthenticated ? (
          <div className="user-info">
            <h3>Account Information</h3>
            <p>Signed in as: {user?.primaryEmailAddress?.emailAddress}</p>
            <p>You'll be notified when new tools are available.</p>
            <div className="user-button-container">
              <UserButton />
            </div>
          </div>
        ) : (
          <div className="sign-in-section">
            <p>Sign in to get updates about new tools:</p>
            <SignIn />
          </div>
        )}
      </div>
    </div>
  );
};

export default MoreTools;
